var exports = {
  "kL": "x31de4314--2d0584--container",
  "O3": "x31de4314--2d0584--underground",
  "mS": "x31de4314--2d0584--transport-time",
};

module.exports = exports;
